export enum CalendarState {
  DEFAULT = 'DEFAULT',
  RESCHEDULE = 'RESCHEDULE',
  SELECT = 'SELECT',
}

export enum CalendarSelectionMode {
  REMOVE = 'REMOVE',
  HOLD = 'HOLD',
  EDIT_PRICE = 'EDIT_PRICE',
}

export enum CalendarRescheduleMode {
  DEFAULT = 'DEFAULT',
  FLEX = 'FLEX',
  ASSIGN_TABLE = 'ASSIGN_TABLE',
}

// this will be today plus this many
export const cacheKeys = 3;
